// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base typography for list screens (toolbar, search, filter, table, pagination) */
:host {
  display: block;
  font-size: 12px;
}

/*
 * Global \`.header-label\` in styles.scss sets font-size: 14px (beats inheritance).
 * Align table headers with list typography when rendered inside this layout.
 */
:host ::ng-deep .header-label {
  font-size: 12px;
}

:host ::ng-deep .table-cell {
  font-size: 12px;
}

/* Consistent spacing between search/filter row and table across all list components */
.list-layout-table-spacing {
  margin-top: 0;
}

.loading-container {
  margin-bottom: 0;
}

.list-toolbar-row {
  margin-bottom: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/layouts/list-layout/list-layout.component.scss"],"names":[],"mappings":"AAAA,kFAAA;AACA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;;;EAAA;AAIA;EACE,eAAA;AACF;;AACA;EACE,eAAA;AAEF;;AACA,sFAAA;AACA;EACE,aAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,sBAAA;AAEF","sourcesContent":["/* Base typography for list screens (toolbar, search, filter, table, pagination) */\n:host {\n  display: block;\n  font-size: 12px;\n}\n\n/*\n * Global `.header-label` in styles.scss sets font-size: 14px (beats inheritance).\n * Align table headers with list typography when rendered inside this layout.\n */\n:host ::ng-deep .header-label {\n  font-size: 12px;\n}\n:host ::ng-deep .table-cell {\n  font-size: 12px;\n}\n\n/* Consistent spacing between search/filter row and table across all list components */\n.list-layout-table-spacing {\n  margin-top: 0;\n}\n\n.loading-container {\n  margin-bottom: 0;\n}\n\n.list-toolbar-row {\n  margin-bottom: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
